import { type Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'
import { Box, Stack, DesktopDatePicker, StackRow } from '@dhl-ui/components'

import { useCanViewPpp } from '~/modules/ppp/hooks'
import { CustomsFiles } from '~/modules/ppp/submodules/customs/components/CustomsFiles'
import { useCustomsDate } from '~/modules/ppp/submodules/customs/hooks/useCustomsDate'

export const PppCustomsPage = () => {
  const canAccess = useCanViewPpp()
  const { t } = useTranslation()

  const { today, from, to } = useCustomsDate()

  return (
    canAccess && (
      <Stack gap={2}>
        <StackRow gap={2}>
          <Box data-testid="ppp-customs-from-date-picker">
            <DesktopDatePicker<Dayjs>
              defaultValue={from.selectedDate}
              value={from.selectedDate}
              label={t('admin.pppCustomsPage.date.from.label')}
              showDaysOutsideCurrentMonth={false}
              maxDate={today}
              onChange={from.onChange}
            />
          </Box>
          <Box data-testid="ppp-customs-to-date-picker">
            <DesktopDatePicker<Dayjs>
              defaultValue={to.selectedDate}
              value={to.selectedDate}
              label={t('admin.pppCustomsPage.date.to.label')}
              showDaysOutsideCurrentMonth={false}
              minDate={from.selectedDate}
              maxDate={today}
              onChange={to.onChange}
            />
          </Box>
        </StackRow>

        <CustomsFiles fromDate={from.unix} toDate={to.unix} />
      </Stack>
    )
  )
}
